import React from 'react';

import { IconProps } from '../../../DefaultIcon';

export function CategoriesIcon({ className }: IconProps) {
  return (
    <svg
      width="80"
      height="80"
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_4_3571)">
        <path
          d="M65.9819 68.8822H2.9003C1.20846 68.8822 0 67.6737 0 65.9819V2.9003C0 1.20846 1.20846 0 2.9003 0H65.9819C67.6737 0 68.8822 1.20846 68.8822 2.9003V65.9819C68.8822 67.6737 67.6737 68.8822 65.9819 68.8822Z"
          fill="#EAEEF9"
        />
        <path
          d="M63.8063 12.3263H5.07515C4.35008 12.3263 3.625 11.6012 3.625 10.8761V5.07553C3.625 4.35046 4.35008 3.62538 5.07515 3.62538H63.8063C64.5313 3.62538 65.2564 4.35046 65.2564 5.07553V10.8761C65.2564 11.6012 64.773 12.3263 63.8063 12.3263Z"
          fill="#00416B"
        />
        <path
          d="M78.5501 19.577H7.25098V33.3535H78.5501V19.577Z"
          fill="#00C4B3"
        />
        <path
          d="M78.55 18.1269H7.25093C6.52586 18.1269 5.80078 18.852 5.80078 19.577V33.3535C5.80078 34.0786 6.52586 34.8036 7.25093 34.8036H78.55C79.2751 34.8036 80.0002 34.0786 80.0002 33.3535V19.577C80.0002 18.852 79.2751 18.1269 78.55 18.1269ZM77.0999 31.9033H8.70108V21.0272H76.8582V31.9033H77.0999Z"
          fill="#00416B"
        />
        <path
          d="M29.0032 42.0544H7.25098V78.3082H29.0032V42.0544Z"
          fill="#FBFCFE"
        />
        <path
          d="M29.0032 40.6042H7.25093C6.52586 40.6042 5.80078 41.3293 5.80078 42.0544V78.3082C5.80078 79.0332 6.52586 79.7583 7.25093 79.7583H29.0032C29.7283 79.7583 30.4534 79.0332 30.4534 78.3082V42.0544C30.4534 41.3293 29.97 40.6042 29.0032 40.6042ZM27.553 77.0997H8.70108V43.5045H27.553V77.0997Z"
          fill="#00416B"
        />
        <path
          d="M78.3083 42.0544H37.7041V78.3082H78.3083V42.0544Z"
          fill="#00C4B3"
        />
        <path
          d="M78.55 40.6042H37.7041C36.979 40.6042 36.2539 41.3293 36.2539 42.0544V78.3082C36.2539 79.0332 36.979 79.7583 37.7041 79.7583H78.3083C79.0334 79.7583 79.7584 79.0332 79.7584 78.3082V42.0544C80.0001 41.3293 79.2751 40.6042 78.55 40.6042ZM77.0998 77.0997H39.1542V43.5045H76.8581V77.0997H77.0998Z"
          fill="#00416B"
        />
        <path
          d="M9.42569 7.97583C9.42569 8.70091 8.70062 9.42598 7.97554 9.42598C7.25047 9.42598 6.52539 8.70091 6.52539 7.97583C6.52539 7.25076 7.25047 6.52568 7.97554 6.52568C8.70062 6.52568 9.42569 7.25076 9.42569 7.97583Z"
          fill="#FBFCFE"
        />
        <path
          d="M15.2265 7.97583C15.2265 8.70091 14.5014 9.42598 13.7763 9.42598C13.0512 9.42598 12.3262 8.70091 12.3262 7.97583C12.3262 7.25076 13.0512 6.52568 13.7763 6.52568C14.5014 6.52568 15.2265 7.25076 15.2265 7.97583Z"
          fill="#FBFCFE"
        />
        <path
          d="M21.0273 7.97583C21.0273 8.70091 20.3022 9.42598 19.5771 9.42598C18.852 9.42598 18.127 8.70091 18.127 7.97583C18.127 7.25076 18.852 6.52568 19.5771 6.52568C20.3022 6.52568 21.0273 7.25076 21.0273 7.97583Z"
          fill="#FBFCFE"
        />
      </g>
      <defs>
        <clipPath id="clip0_4_3571">
          <rect width="80" height="80" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
